<template>
  <div>
    <div
      class="modal fade"
      id="book-master-achieved-component"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div
        class="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-custom"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header bg-white justify-content-between align-items-center">
            <div class="flex-grow-1 w-0">
              <button type="button" class="btn btn-light text-black-50 pl-1" @click="close">
                <i class="icon icon-close _sm"></i>
                关闭
              </button>
            </div>
            <h5 class="modal-title text-center">{{ Book.bookName }}</h5>
            <div class="flex-grow-1 w-0"></div>
          </div>
          <div class="modal-body p-0 bg-dark text-white text-center">
            <div
              class="h-full d-flex flex-column justify-content-center align-items-center overflow-hidden"
            >
              <div class="mb-7 book-to-master">
                <div class="book-to-master-bg animated zoomIn">
                  <img
                    src="https://resources.pzacademy.com/image/class-ui/book-to-master-bg.svg"
                    style="opacity: 0.75"
                  />
                </div>

                <div
                  class="book-icon animated bounceIn fast"
                  :style="{ backgroundImage: `url('${Book.bookIcon}')` }"
                ></div>
                <div
                  class="book-level _master animated bounceInDown fast"
                  :class="`_v${Book.currentColor}`"
                  style="animation-dalay: 0.5s"
                ></div>
                <div class="_17ac5n34">
                  <svg
                    role="img"
                    aria-hidden="true"
                    class="_1w7dtjpw"
                    focusable="false"
                    width="55"
                    height="55"
                    viewBox="0 0 17 17"
                    style="animation-delay: 1s"
                  >
                    <path
                      fill="#ffffff"
                      d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
      3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                    />
                  </svg>
                </div>
                <div class="_176g09a4">
                  <svg
                    role="img"
                    aria-hidden="true"
                    class="_1w7dtjpw"
                    focusable="false"
                    width="22"
                    height="22"
                    viewBox="0 0 17 17"
                    style="animation-delay: 2s"
                  >
                    <path
                      fill="#ffffff"
                      d="M17 9c-4.694-.5-8.5-4.306-9-9 .5 4.694-3.306 8.5-8 9 4.694-.5 8.5
          3.306 8 8 .5-4.694 4.306-8.5 9-8z"
                    />
                  </svg>
                </div>
              </div>
              <div class="w-p50 mb-5">
                <h2 class="text-center mb-5 animated fadeInUp" style="animation-delay: 0.5s">
                  该科目已到达最高级别！
                </h2>
                <p class="lead text-white-70 animated fadeInUp" style="animation-delay: 0.7s">
                  你已经掌握了这门科目并获得了{{ Book.totalPoints }}分。{{
                    Book.nextBookName ? `请进入下一科目: ${Book.nextBookName}` : ''
                  }}
                </p>
              </div>
            </div>
          </div>
          <div class="modal-footer bg-white justify-content-between">
            <div class="modal-footer-left"></div>
            <div class="modal-footer-right">
              <button type="button" class="btn btn-lg btn-primary" @click="close">关闭</button>
              <!-- <button
                v-if="Book.nextBookName"
                type="button"
                class="btn btn-primary btn-lg"
                @click="onGoToNextBook()"
              >查看下一科目</button>-->
            </div>
          </div>
          <div class="book-master-achieved">
            <canvas style="width: 100%; height: 100%"></canvas>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery';

export default {
  name: 'BookMasterAchieved',

  props: {
    visiable: {
      type: Boolean,
      default: () => false,
    },

    onClose: {
      type: Function,
      default: () => {},
    },

    onGoToNextBook: {
      type: Function,
      default: () => {},
    },

    Book: {
      type: Object,
      default: () => {},
    },
  },

  computed: {},

  watch: {
    visiable: function (v) {
      if (v) {
        $(`#book-master-achieved-component`).modal({
          backdrop: 'static',
          keyboard: false,
        });
      }
    },
  },

  mounted() {
    $(`#book-master-achieved-component`).on('hidden.bs.modal', (e) => {
      this.onClose();
    });
  },

  beforeDestroy() {
    this.close();
  },

  methods: {
    close() {
      $(`#book-master-achieved-component`).modal('hide');
      this.onClose();
    },

    goToNextBook() {
      this.close();
      this.onGoToNextBook();
    },
  },
};
</script>
<style lang="scss" scoped>
.book-master-achieved {
  left: 0px !important;
  top: 0px !important;
  position: fixed !important;
  z-index: 200000 !important;
  pointer-events: none !important;
  width: 100%;
  height: 100%;
  right: 0px !important;
  bottom: 0px !important;
  -webkit-filter: Alpha(opacity=0) !important;
  filter: Alpha(opacity=0) !important;
}
</style>
